import PropTypes from 'prop-types';
import TextCaption from './TextCaption';
import React from 'react';
import CurrencyInput from 'react-currency-input-field';

const TextField = (props) => {
  const {
    variant = 'primary',
    size = 'small',
    label = '',
    placeholder = '',
    status = '',
    name = '',
    className = '',
    message = '',
    unit = '',
    disabled,
    value,
    onChange,
    onClick,
    onBlur,
    icon,
    leftIcon,
    unitAction,
    unitStyle,
    pattern = '',
    isCurency,
    isPassword,
    suffix = '',
    prefix = '',
    bolderValue,
    customPadding,
    onPress,
    marginTop = 'mt-2',
    isFocus,
    isPhone,
  } = props;

  const inputRef = React.useRef();

  React.useEffect(() => {
    if (isFocus) inputRef.current.focus();
  }, [isFocus]);

  return (
    <>
      {label !== '' && (
        <label
          className={variant === 'primary' ? 'text-sm text-blue-hedgehog bold-text-2' : 'text-sm text-gray-davys bold-text-2'}
        >
          {label}
        </label>
      )}
      <div
        className={`${className && className} ${size + '-text-field'} ${marginTop} ${variant + '-text-field'} ${
          customPadding ? customPadding : ' py-2 px-3'
        } ${status + '-text-field  flex justify-between items-center'}`}
      >
        {!unit && leftIcon && leftIcon}
        {isPhone && <p className="text-gray-spain">+62</p>}

        {isCurency ? (
          <CurrencyInput
            style={{
              padding: 0,
              border: 0,
              backgroundColor: 'rgba(235, 238, 255, var(--tw-bg-opacity))',
              boxShadow: 'none',
            }}
            className="w-full bg-blue-magnolia focus:outline-none outline-none"
            id="input-example"
            name={name}
            placeholder={placeholder}
            defaultValue={0}
            decimalsLimit={2}
            value={value}
            onValueChange={(value, name) => onChange(value, name)}
            prefix={prefix}
            suffix={suffix}
          />
        ) : isPassword ? (
          <input
            ref={inputRef}
            type="password"
            pattern={pattern}
            onChange={onChange}
            placeholder={placeholder}
            style={{ boxShadow: 'none', padding: 0 }}
            className={`bg-gray-culture rounded-lg text-sm border-none focus:outline-none bg-none w-full ml-1  ${
              disabled && 'cursor-not-allowed text-gray-silver'
            } ${bolderValue && 'font-semibold text-gray-davys'} `}
            value={value}
            name={name}
            onClick={onClick}
            onBlur={onBlur}
            disabled={disabled}
            onKeyDown={onPress}
          />
        ) : (
          <input
            ref={inputRef}
            pattern={pattern}
            onChange={onChange}
            placeholder={placeholder}
            className={`${variant + '-text-field'} focus:outline-none bg-none w-full ml-1  ${
              disabled && 'cursor-not-allowed text-gray-silver'
            } ${bolderValue && 'font-semibold text-gray-davys'} `}
            value={value}
            name={name}
            onClick={onClick}
            onBlur={onBlur}
            disabled={disabled}
            onKeyDown={onPress}
          />
        )}

        {!icon && unit !== '' && (
          <span className={`whitespace-nowrap cursor-pointer ${unitStyle}`} onClick={unitAction && unitAction}>
            {unit}
          </span>
        )}
        {!unit && icon && icon}
      </div>
      {status !== '' && (
        <span className="mb-5">
          <TextCaption className="mt-2" status={status} message={message} />
        </span>
      )}
    </>
  );
};

TextField.propTypes = {
  status: PropTypes.string,
  disabled: PropTypes.bool,
  isCurency: PropTypes.bool,
  suffix: PropTypes.string,
  prefix: PropTypes.string,
  variant: PropTypes.string,
  message: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onPress: PropTypes.func,
  unitAction: PropTypes.func,
  unitStyle: PropTypes.string,
  pattern: PropTypes.string,
  customPadding: PropTypes.string,
  bolderValue: PropTypes.bool,
  isFocus: PropTypes.bool,
};

export default TextField;
